import { NAV_HEIGHT } from 'layouts/AppPageTemplate/utils/config';
import React, { createContext, useState, useContext } from 'react';

interface NavHeightContextValues {
  marginTop: number;
  adjustMarginTop: (newMargin: number) => void;
}

export const NavHeightContext = createContext<NavHeightContextValues | undefined>(undefined);

export const NavHeightProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [marginTop, setMarginTop] = useState(NAV_HEIGHT);

  const adjustMarginTop = React.useCallback(
    (newMargin: number) => {
      setMarginTop(NAV_HEIGHT + newMargin);
    },
    [setMarginTop]
  );

  const value = React.useMemo(() => ({ marginTop, adjustMarginTop }), [marginTop, adjustMarginTop]);

  return <NavHeightContext.Provider value={value}>{children}</NavHeightContext.Provider>;
};

export function useNavHeightContext() {
  const context = useContext(NavHeightContext);
  if (context === undefined) {
    throw new Error('useNavHeightContext must be used within a NavHeightProvider');
  }
  return context;
}
